import { Download, X } from 'lucide-react';
import { useTranslation } from '@bms/common';
import { Button } from '@/components/ui/button';
import { useInstallPrompt } from '@/hooks/use-install-prompt';

// ============================================================================
// InstallPrompt — dismissible "Add to Home Screen" banner
// Only renders once the browser has fired beforeinstallprompt and the user
// hasn't dismissed it before (see useInstallPrompt / localStorage).
//
// It is a slim strip at the top of the shell, in normal flow. As a bottom
// overlay it sat exactly where sonner stacks its toasts, so an install prompt
// and a "lost connection" toast covered each other; it also floated over the
// iOS home indicator. Rendered here it pushes the header down instead.
// ============================================================================

export function InstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, promptInstall, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div className="flex shrink-0 items-center gap-2 border-b bg-muted/60 px-3 py-1.5 text-ui sm:px-4">
      <Download className="h-4 w-4 shrink-0 text-primary-text" />
      <p className="min-w-0 flex-1 truncate">
        <span className="font-medium">{t('shell.install.title')}</span>
        <span className="ml-2 text-muted-foreground">{t('shell.install.description')}</span>
      </p>
      <Button size="sm" className="h-7 shrink-0 text-caption" onClick={promptInstall}>
        {t('shell.install.action')}
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0 text-muted-foreground"
        onClick={dismiss}
        aria-label={t('shell.install.dismiss')}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
